import { DateTime } from "luxon";

export const formatEventTime = (timestamp: string, locale: string) => {
    // Convert bigint string to number and then to Luxon DateTime
    const timestampNumber = parseInt(timestamp, 10);
    const dateTime = DateTime.fromSeconds(timestampNumber);

    return dateTime.setLocale(locale).toLocaleString(DateTime.DATETIME_MED);
};